import { useSiteSettings } from '@/brands';
import { useAppSelector } from '@/hooks/redux';
import ChangePasswordModal from '@/components/ChangePasswordModal';

/**
 * Holds a logged-in player on a mandatory password change.
 *
 * Applies only when the brand has Force Change Password on AND the account has
 * never had its password changed (`passwordChanged === false` — accounts the
 * operator created carry the password the operator chose). The modal has no
 * dismiss control, so rendering it is the block; it disappears on its own once
 * the change succeeds and `getUserInfo` refetches.
 *
 * Mounted once, above the router, so it covers deep links and reloads — not
 * just the moment right after login.
 */
export function ForcePasswordGate() {
  const { forceChangePassword } = useSiteSettings();
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const info = useAppSelector((s) => s.user.info);

  // `passwordChanged` is nullable server-side; only an explicit false forces.
  const mustChange = info?.passwordChanged === false;
  if (!forceChangePassword || !isAuthenticated || !mustChange) return null;

  return <ChangePasswordModal open required onClose={() => {}} />;
}
